import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../../lang/front/en.json';
import translationFR from '../../lang/front/fr.json';
import translationES from '../../lang/front/es.json';
import translationAL from '../../lang/front/al.json';

const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    },
    es: {
        translation: translationES
    },
    al: {
        translation: translationAL
    },
};
const options = {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage'],

}

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: options,
        resources,
        fallbackLng: 'en',
        // fallback, can be a string or an array of namespaces
        fallbackNS: 'common', // display "fr" instead of "fr-FR"
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
